import { Helmet } from 'react-helmet';
import { useNavigate } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useEffect } from 'react';
import ScrollToTop from '../../../components/ScrollToTop';
const TermsOfService = () => {
    const navigator = useNavigate();

    useEffect(()=>{

    },[])
    return (
        <>
            <Helmet>
                <title>Terms of Service | TLK</title>
            </Helmet>
            {/* start: terms page */}
            <ScrollToTop />
            <div className="min-h-screen gradient-bg-1">
                {/* <div className="fixed w-full top-0 bg-background/95 backdrop-blur-sm border-b border-border px-4 py-3 flex items-center gap-3 z-10">
                    <button className=""
                        onClick={() => navigator(-1)}
                    >
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width={24}
                            height={24}
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth={2}
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            className="lucide lucide-arrow-left w-6 h-6"
                        >
                            <path d="m12 19-7-7 7-7" />
                            <path d="M19 12H5" />
                        </svg>
                    </button>
                    <h1 className="text-lg font-semibold ">Terms of Service</h1>
                </div> */}
                <header className="cs-header">
                    <div className="cs-header-left">
                        <button type="button" className="cs-back-btn" onClick={() => navigator(-1)} aria-label="Go back">
                            <ArrowBackIcon fontSize="small" />
                        </button>
                        <div className="cs-title">
                            <span className="cs-bar"></span>
                            <h1>Terms of Service</h1>
                        </div>
                    </div>
                    <div className="cs-updated"> Last updated: July 2026</div>
                </header>
                <div
                    className="p-6 pt-[100px] max-w-2xl mx-auto"
                    style={{ opacity: 1, transform: "none" }}
                >
                    {/* <p className="text-sm  mb-6">
                        Last updated: July 2026
                    </p> */}
                    <div className="space-y-6 /90 text-sm leading-relaxed">
                        <section>
                            <h2 className="text-lg font-semibold  mb-3">
                                1. Acceptance of Terms
                            </h2>
                            <p>
                                By accessing or using Syntimacy ("Service"), you agree to be bound by
                                these Terms of Service. If you do not agree to these terms, please do
                                not use our Service.
                            </p>
                        </section>
                        <section>
                            <h2 className="text-lg font-semibold  mb-3">
                                2. Age Requirement
                            </h2>
                            <p>
                                You must be at least 18 years of age to use this Service. By using
                                Syntimacy, you represent and warrant that you are at least 18 years
                                old. We verify age at signup and reserve the right to terminate
                                accounts that violate this requirement.
                            </p>
                        </section>
                        <section>
                            <h2 className="text-lg font-semibold  mb-3">
                                3. Account Registration
                            </h2>
                            <p>
                                To access certain features, you may need to create an account. You are
                                responsible for maintaining the confidentiality of your account
                                credentials and for all activities under your account.
                            </p>
                        </section>
                        <section>
                            <h2 className="text-lg font-semibold  mb-3">
                                4. Subscription &amp; Billing
                            </h2>
                            <p className="mb-2">
                                Syntimacy offers subscription plans with varying features and pricing. Current plan details and pricing are displayed within the Service at the time of purchase.
                            </p>
                            {/* <ul className="list-disc list-inside space-y-1 ml-2">
                                <li>Starter Plan: $7.99/month</li>
                                <li>Standard Plan: $12.99/month</li>
                                <li>Premium Plan: $19.99/month</li>
                            </ul> */}
                            <p className="mt-2">
                                Payments are processed securely by Stripe. Subscriptions automatically renew unless cancelled before the renewal date. You may cancel your subscription at any time through your account settings. Refunds are handled on a case-by-case basis.
                            </p>
                        </section>
                        <section>
                            <h2 className="text-lg font-semibold  mb-3">
                                5. User Conduct
                            </h2>
                            <p className="mb-2">You agree not to:</p>
                            <ul className="list-disc list-inside space-y-1 ml-2">
                                <li>
                                    Share, distribute, or publicly display content from the Service
                                </li>
                                <li>Use the Service for any illegal purpose</li>
                                <li>Harass, abuse, or harm others through the Service</li>
                                <li>
                                    Attempt to circumvent security measures or access restrictions
                                </li>
                                <li>Use automated systems or bots to access the Service</li>
                                <li>
                                    Record, screenshot, or capture content without explicit permission
                                </li>
                            </ul>
                        </section>
                        <section>
                            <h2 className="text-lg font-semibold  mb-3">
                                6. Content &amp; Intellectual Property
                            </h2>
                            <p>
                                All content provided through Syntimacy, including text, images, audio,
                                and video, is owned by or licensed to Syntimacy and its creators. You
                                may not reproduce, distribute, or create derivative works without
                                explicit written permission.
                            </p>
                        </section>
                        <section>
                            <h2 className="text-lg font-semibold  mb-3">
                                7. Your Data Rights
                            </h2>
                            <p className="font-medium  mb-2">
                                Your information is private—always and forever.
                            </p>
                            <p>
                                Your conversation history belongs to you. You may delete your data at
                                any time through your account settings. Upon deletion, your data is
                                permanently removed from our systems. See our Privacy Policy for
                                complete details.
                            </p>
                        </section>
                        <section>
                            <h2 className="text-lg font-semibold  mb-3">
                                8. Service Availability
                            </h2>
                            <p>
                                We strive to maintain 24/7 availability but do not guarantee
                                uninterrupted access. We reserve the right to modify, suspend, or
                                discontinue the Service at any time.
                            </p>
                        </section>
                        <section>
                            <h2 className="text-lg font-semibold  mb-3">
                                9. Limitation of Liability
                            </h2>
                            <p>
                                Syntimacy is provided "as is" without warranties of any kind. We are
                                not liable for any indirect, incidental, or consequential damages
                                arising from your use of the Service.
                            </p>
                        </section>
                        <section>
                            <h2 className="text-lg font-semibold  mb-3">
                                10. Termination
                            </h2>
                            <p>
                                We may terminate or suspend your account at our discretion for
                                violations of these Terms. You may terminate your account at any time
                                by contacting support or through account settings.
                            </p>
                        </section>
                        <section>
                            <h2 className="text-lg font-semibold  mb-3">
                                11. Changes to Terms
                            </h2>
                            <p>
                                We may update these Terms from time to time. Continued use of the
                                Service after changes constitutes acceptance of the new Terms.
                            </p>
                        </section>
                        <section>
                            <h2 className="text-lg font-semibold  mb-3">
                                12. Contact
                            </h2>
                            <p>
                                For questions about these Terms, please contact us at
                                support@syntimacy.co
                            </p>
                        </section>
                        <section>
                            <h2 className="text-lg font-semibold  mb-3">
                                13. AI Processing & Third-Party Services
                            </h2>
                            <p>
                                The Service uses artificial intelligence to generate companion responses to your messages, and third-party AI services to enable voice and video features. By using the Service, you consent to your messages and voice audio being processed as described in our Privacy Policy.
                                A full list of third-party service providers, what data they receive, and links to their privacy policies is available in our Privacy Policy under "Third-Party Services" and "AI Data Processing."
                            </p>
                        </section>
                    </div>
                    <div className="mt-8 pt-6 border-t border-border">
                        <p className="text-xs  text-center">
                            Copyright 2026 Syntimacy LLC. All rights reserved.
                        </p>
                    </div>
                </div>
            </div>
            {/* end: terms page */}
        </>
    );
}

export default TermsOfService;
